import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
// services
import levelService from "services/level.service";
import unityService from "services/unity.service";
// util
import Notifications from "views/Notifications/Notifications";

const styles = (theme) => ({
	cardCategoryWhite: {
		color: "rgba(255,255,255,.62)",
		margin: "0",
		fontSize: "14px",
		marginTop: "0",
		marginBottom: "0",
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
	},
});

class CadastrarUnidades extends Component {
	constructor(props) {
		super(props);
		this.state = {
			levels: [],
			selectedLevel: "",
			title: "",
			order: 0,
			resume: "",
			audio: "",
			notification: { show: false, message: "", type: "info" },
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSearch();
	}

	handleSearch() {
		const tableLevels = [];

		levelService.listAllLevels().then((levels) => {
			levels.forEach((level) => {
				tableLevels.push({
					key: level.key,
					value: level.key,
					label: `${level.title} (${
						level.language === "english"
							? "Inglês"
							: level.language === "spanish"
							? "Espanhol"
							: level.language
					}) - ${level.key}`,
				});
			});

			this.setState({ levels: tableLevels });
		});
	}

	handleChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === "file" ? target.files[0] : target.value;

		this.setState({
			[name]: value,
		});
	}

	handleSubmit(event) {
		this.setState({
			notification: {
				show: true,
				message: "Aguarde o envio dos arquivos!",
				type: "info",
			},
		});
		unityService
			.createUnity({ ...this.state, order: parseFloat(this.state.order) })
			.then((res) =>
				this.showNotification(
					"Unidade cadastrada com sucesso!",
					"success"
				)
			)
			.catch((err) =>
				this.showNotification(
					"Ocorreu um erro ao tentar cadastrar unidade! " + err,
					"danger"
				)
			);
	}

	showNotification(message, type) {
		if (this.state.notification.show === true)
			this.setState({ notification: { show: false } });
		this.setState({
			notification: { show: true, message: message, type: type },
		});
		setTimeout(() => {
			this.setState({
				notification: { show: false, message: "", type: "info" },
			});
			this.props.onClose();
		}, 3000);
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<GridContainer>
					<GridItem xs={12} sm={12} md={12}>
						<Card>
							<CardHeader color="primary">
								<h4 className={classes.cardTitleWhite}>
									Cadastrar Unidade
								</h4>
								<p className={classes.cardCategoryWhite}>
									Complete as informações para o cadastro
								</p>
							</CardHeader>
							<CardBody>
								<GridContainer>
									<GridItem xs={12} sm={12} md={12}>
										<CustomSelect
											labelText="Livro da Unidade"
											id="level"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "text",
												name: "selectedLevel",
												value: this.state.selectedLevel,
												onChange: this.handleChange,
											}}
											selectItems={this.state.levels}
										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={2}>
										<CustomInput
											labelText="Ordem da Unidade"
											id="order"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "number",
												name: "order",
												value: this.state.order,
												onChange: this.handleChange,
											}}
										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={10}>
										<CustomInput
											labelText="Título da Unidade"
											id="title"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "text",
												name: "title",
												value: this.state.title,
												onChange: this.handleChange,
											}}
										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={6}>
										<CustomInput
											labelText="Resumo"
											id="resume"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "file",
												name: "resume",
												onChange: this.handleChange,
											}}
										/>
										<InputLabel id="label">
											Resumo
										</InputLabel>
									</GridItem>
									<GridItem xs={12} sm={12} md={6}>
										<CustomInput
											labelText="Áudio"
											id="audio"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "file",
												name: "audio",
												onChange: this.handleChange,
											}}
										/>
										<InputLabel id="label">
											Áudio
										</InputLabel>
									</GridItem>
								</GridContainer>
							</CardBody>
							<CardFooter>
								<Button
									color="primary"
									type="submit"
									round
									onClick={(event) => {
										this.handleSubmit(event);
									}}
								>
									Cadastrar
								</Button>
							</CardFooter>
						</Card>
					</GridItem>
					{this.state.notification.show === true ? (
						<Notifications notification={this.state.notification} />
					) : null}
				</GridContainer>
			</div>
		);
	}
}

CadastrarUnidades.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CadastrarUnidades);
